import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { capitalize } from '@mui/material/utils';
import { filterUrl } from "./Find"
import { useLayoutData } from "../../../utils/contexts/LayoutContext"
import dynamic from "next/dynamic"
import { useMemo } from "react"
import { FindMobileListItemButtonProps } from "./FindDesignTypes"
import Link from "next/link"
import { PageType } from "../../../pages/_app"
import { FindFilterMobileListItemProps } from "./Find.types"

const FindFilterMobileListItem = ({
	filters,
	item,
	multiSelect,
	colors,
	pageUrl,
	mmbr,
	closeSubmenu
}: FindFilterMobileListItemProps) => {
	const { partnerSiteFull, templatePath } = useLayoutData()

	const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath
	
	const FindMobileListItemButton = useMemo(() => dynamic<FindMobileListItemButtonProps>(() => import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindMobileListItemButton)), [path])
	
	const handleClose = () => {
		setTimeout(() => {
			closeSubmenu && closeSubmenu()
		}, 1000)

		console.log('FindFilterMobileListItem: handleClose')
	}

	return (
		<Stack>
			<ListItem
				disablePadding
				secondaryAction={<Typography>({item.count})</Typography>}
				sx={{ display: 'inline-block' }}
			>
				<Link href={multiSelect ? pageUrl as string : filterUrl(filters, item, undefined, pageUrl, mmbr)} passHref>
					<a>
						<FindMobileListItemButton selected={item.selected} selectedcolor={colors.mainColor} onClick={() => !multiSelect ? handleClose() : undefined}>
							<ListItemIcon>
								{multiSelect ? (
									<Checkbox 
										checked={item.selected ?? false} 
										inputProps={{
											"aria-label": item?.title
										}}
									/>
								) : (
									<Radio 
										name="options"
										checked={item.selected}
										value={item.selected}
										inputProps={{
											"aria-label": item?.title
										}}	
									/>
								)}
							</ListItemIcon>
							<ListItemText primary={
								<Typography fontSize={"16px"}>
									{capitalize(item.title as string)} {item.text ? <Typography component={'span'} display={"inline-block"} fontSize={"11px"}>({item.text})</Typography> : null}
								</Typography>
							} />
						</FindMobileListItemButton>
					</a>
				</Link>
			</ListItem>
			<Divider />
		</Stack>
	)
}

export default FindFilterMobileListItem